/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2023, Bulb Inc.  For more information, please email contact@hellobulb.com.
 */

/**
 * Controller to handle opening a logged out modal if a user sessions expires.
 */
angular.module('bulbApp.alertsModule')
  .controller('LoggedOutAlertController', ['$scope', '$translate', '$window', 'AeroDialogService', 'BulbAuthService',
    'LoggedOutService', LoggedOutAlertController]);

function LoggedOutAlertController(
  $scope,
  $translate,
  $window,
  AeroDialogService,
  BulbAuthService,
  LoggedOutService,
) {
  this.showVersionAlert = false;

  /**
   * Listener for changes on the logged status.
   * Opens a logged out modal if case is met.
   */
  $scope.$watch(() => LoggedOutService.isLoggedIn, (newStatus) => {
    // If the previous status was logged in, and the new one is not, show the logged out modal.
    if (newStatus === false && LoggedOutService.wasPreviouslyLoggedIn === true) {
      AeroDialogService.showDialog({
        icon: 'fa fa-exclamation-triangle',
        iconClass: 'aero-alert',
        title: $translate.instant('logged_out_modal_title'),
        detail: $translate.instant('logged_out_modal_details'),
        closable: false,
        primaryLabel: $translate.instant('sign_in_button'),
        onPrimary: () => {
          // This is needed because the modal is not closable, and with the current service it is the only way to remove
          // a dialog that isn't closable.
          AeroDialogService.removeDialog();
          BulbAuthService.signOut(`/b/sign-in?targetUrl=${$window.location.href}`);
        },
        showSecondary: false,
      });
    }
  });
}
